// @flow

import Waveform from '../model/entity/Waveform';
import * as types from '../constants/ActionTypes';

const initialState: Waveform = new Waveform();

export default (waveformLayout: Waveform = initialState, action: Object) => {
  switch (action.type) {
    case types.SET_WAVEFORM_LAYOUT: {
      return {
        ...waveformLayout,
        waveformLayout: action.layout,
      };
    }

    case types.SET_WAVEFORM_HTML_ELEMENT: {
      const newWaveformLayout = { ...waveformLayout };
      newWaveformLayout.htmlElements[action.index] = action.element;
      return newWaveformLayout;
    }

    case types.SET_WAVEFORM_VIEW_INDEX: {
      return {
        ...waveformLayout,
        waveformLayoutViewIndex: action.index,
      };
    }

    case types.SET_WAVEFORM_SCALE_FACTOR: {
      return {
        ...waveformLayout,
        scaleFactor: action.scaleFactor,
      };
    }

    case types.SET_WAVEFORM_TIME_FACTOR: {
      return {
        ...waveformLayout,
        timeFactor: action.timeFactor,
      };
    }

    default: {
      return waveformLayout;
    }
  }
};
